import { createAction, props } from '@ngrx/store';
import { RequestTermsAndConditionsManagerCreate, ResponseTermsAndConditionsManagerCreate } from '../../shared/interfaces';
import { TermsAndConditionsManagerCreateTypes } from '../../shared/enums';

export const getTermsAndConditionsManagerCreate = createAction(
    TermsAndConditionsManagerCreateTypes.TERMS_AND_CONDITIONS_MANAGER_CREATE,
    props<{ request: RequestTermsAndConditionsManagerCreate}>()
);

export const getTermsAndConditionsManagerCreateSucess = createAction(
    TermsAndConditionsManagerCreateTypes.TERMS_AND_CONDITIONS_MANAGER_CREATE_SUCCESS,
    props<{ response: ResponseTermsAndConditionsManagerCreate }>()
);

export const getTermsAndConditionsManagerCreateError = createAction(
    TermsAndConditionsManagerCreateTypes.TERMS_AND_CONDITIONS_MANAGER_CREATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    TermsAndConditionsManagerCreateTypes.CLEAN_STATE
);

